import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { CtaButton } from '@/components/Cta/Cta';
import { X } from '@/public/icons/account/icons';

import SidebarFilters from './SidebarFilters';
import { FiltersModalProps } from './types';

const FiltersModal = ({
  options,
  priceRange,
  isFilterOpen,
  setIsFilterOpen,
  handleFilterChange,
  searchParams,
  clearAllFilters,
  shouldShowClearAll,
  isLoading,
  fixedVariantFilters,
  handlePriceRangeChange,
  allVisibleFiltersSelected,
  lastAllFiltersUnselected,
  productGroupName,
  categoryPk,
}: FiltersModalProps) => (
  <Transition appear show={isFilterOpen} as={Fragment}>
    <Dialog
      as="div"
      className="relative z-50 h-[100dvh] lg:hidden"
      onClose={setIsFilterOpen}
    >
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex h-full w-screen items-center justify-center text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-150"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="flex h-full w-full flex-col overflow-hidden bg-white text-left align-middle transition-all">
              <Dialog.Title
                as="h3"
                className="flex items-center justify-between bg-gray-500 px-5 py-3 text-lg font-extrabold leading-6  text-gray-700"
              >
                Filters
                <button
                  type="button"
                  className="outline-none"
                  onClick={() => setIsFilterOpen(false)}
                >
                  <X className="h-5 w-5 fill-gray-700" />
                </button>
              </Dialog.Title>
              <div className="flex-1 overflow-auto p-2">
                <SidebarFilters
                  options={options}
                  priceRange={priceRange}
                  handleFilterChange={handleFilterChange}
                  searchParams={searchParams}
                  clearAllFilters={clearAllFilters}
                  shouldShowClearAll={shouldShowClearAll}
                  isLoading={isLoading}
                  fixedVariantFilters={fixedVariantFilters}
                  handlePriceRangeChange={handlePriceRangeChange}
                  allVisibleFiltersSelected={allVisibleFiltersSelected}
                  lastAllFiltersUnselected={lastAllFiltersUnselected}
                  categoryPk={categoryPk || productGroupName}
                />
              </div>
              <div className="w-full bg-white p-5 shadow">
                <CtaButton
                  onClick={() => setIsFilterOpen(false)}
                  type="button"
                  className="w-full bg-gray-700 p-2.5 text-base text-white"
                >
                  View Results
                </CtaButton>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition>
);

export default FiltersModal;
